module.exports = import("https://unpkg.com/@cortex-js/compute-engine?module");;